// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__7zzkA","link":"Button_link__p8vio","default":"Button_default__lwjD3","button--isMenu":"Button_button--isMenu__6IrsS","narrow":"Button_narrow__7enjk"};